import { isBooleanArrayParameter, isBooleanParameter, isStringArrayParameter, isStringParameter, isTupleArrayParameter, isTupleParameter, } from "@blockwell/eth-types";
export function isStructResponse(res) {
    if (typeof res === "number" || typeof res === "boolean" || typeof res === "string") {
        return false;
    }
    if (Array.isArray(res)) {
        return false;
    }
    return !!res;
}
export function isArrayResponse(res) {
    return Array.isArray(res);
}
export function isPrimitiveResponse(res) {
    return !Array.isArray(res) && !isStructResponse(res);
}
export function ethParamToChainResponse(param) {
    if (isStringArrayParameter(param) || isBooleanArrayParameter(param)) {
        return param.values;
    }
    if (isStringParameter(param) || isBooleanParameter(param)) {
        return param.value;
    }
    if (isTupleArrayParameter(param)) {
        return param.values.map(ethParamToChainResponse);
    }
    if (isTupleParameter(param)) {
        return Object.fromEntries(param.components.map((comp) => [comp.name, ethParamToChainResponse(comp)]));
    }
    return param.hash;
}
